"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCaseExemptions;

var _Asset = _interopRequireDefault(require("./Asset"));

var _Exemption = _interopRequireDefault(require("./Exemption"));

var _Rule = _interopRequireWildcard(require("./Rule"));

var _MapWithDefault = _interopRequireDefault(require("./MapWithDefault"));

var _jurisdictions = require("./jurisdictions");

var _getExemptionRulesWithContext = _interopRequireDefault(require("./getExemptionRulesWithContext"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Returns true if an asset is in a list of exemption declarations


function isAssetInDeclarations(declarations, asset) {
  return declarations.some(function (dec) {
    return dec.asset === asset;
  });
} // Transform an array of marked rules and assets into a map of Assets to Exemptions


function getExemptionDeclarations(rules, assets) {
  var exemptionsDeclarations = new _MapWithDefault["default"]([]); // For each asset, get the rules where the asset is in the exemption declarations

  assets.forEach(function (asset) {
    var filteredRules = rules.filter(function (r) {
      return isAssetInDeclarations(r.assetsDeclared, asset);
    }); // Build an exemption object for each time the asset appears in a rule's declarations

    filteredRules.forEach(function (rule) {
      var existingExemptions = exemptionsDeclarations.get(asset);
      var updatedExemptions = existingExemptions.concat(rule.assetsDeclared.filter(function (dec) {
        return dec.asset === asset;
      }));
      exemptionsDeclarations.set(asset, updatedExemptions);
    });
  });
  return exemptionsDeclarations;
} // Returns how much of an asset can be exempted for this rule


function getAssetValueToApplyToRule(rule, asset) {
  return Math.min(rule.getAmountRemaining(), asset.valueRemaining, rule.limitPerItem);
} // Take Rule reference and modify fields to add Asset


function applyRule(rule, asset) {
  var value = getAssetValueToApplyToRule(rule, asset);
  var declaration = new _Exemption["default"](asset, rule, value);
  rule.assetsDeclared.push(declaration); // eslint-disable-next-line no-param-reassign

  rule.currentAmount += value; // eslint-disable-next-line no-param-reassign

  asset.valueRemaining -= value;
} // Gets wildcard rule


function findWildcard(exemptionRules) {
  return exemptionRules.find(function (rule) {
    return rule.id === _Rule.WILDCARD_ID;
  });
}

function getCaseExemptions(caseObj, assets) {
  var jurisdiction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _jurisdictions.FEDERAL;
  var groupBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'asset';
  var exemptionRules = (0, _getExemptionRulesWithContext["default"])(caseObj, jurisdiction);
  var wildcard = findWildcard(exemptionRules); // For each asset, mark the Rules that you can exempt the asset under

  assets.forEach(function (asset) {
    var bestPartial = null;
    var bestPartialValue = 0;
    var canApplyRule = false;
    var ruleApplied = false;

    for (var i = 0; i < exemptionRules.length; i += 1) {
      var rule = exemptionRules[i];
      canApplyRule = rule.canApply(asset);
      var assetValueToApply = getAssetValueToApplyToRule(rule, asset); // If we can apply the full asset value to the rule, apply it and end search

      if (!rule.isWildcard() && canApplyRule && assetValueToApply === asset.totalValue) {
        applyRule(rule, asset);
        ruleApplied = true;
        break; // If we could only apply partial asset value and it's better than the previous bestPartial,
        // mark it as our best partial and continue search
      } else if (!rule.isWildcard() && canApplyRule && assetValueToApply > bestPartialValue) {
        bestPartial = rule;
        bestPartialValue = assetValueToApply;
        canApplyRule = false;
      }
    } // If we never applied a single rule, but we have a partial, split it between the partial
    // and wildcard


    if (bestPartial != null && asset.valueRemaining > 0) {
      ruleApplied = true;
      applyRule(bestPartial, asset);

      if (wildcard != null) {
        applyRule(wildcard, asset);
      } // Otherwise apply wildcard fully

    } else if (wildcard != null && wildcard.canApply(asset) && asset.valueRemaining > 0 && wildcard.currentAmount < wildcard.limitAggregate) {
      ruleApplied = true;
      applyRule(wildcard, asset);
    } // Apparently, $0 assets should still get wildcard coverage


    if (asset.totalValue === 0 && wildcard != null && ruleApplied === false) {
      applyRule(wildcard, asset);
    }
  }); // Transform the marked rules and assets into exemption declarations

  if (groupBy === 'asset') return getExemptionDeclarations(exemptionRules, assets);
  if (groupBy === 'rule') return exemptionRules;
  return exemptionRules;
}